import { render, staticRenderFns } from "./ReviewerAssignment.vue?vue&type=template&id=36fb3ebe&scoped=true"
import script from "./ReviewerAssignment.vue?vue&type=script&lang=js"
export * from "./ReviewerAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fb3ebe",
  null
  
)

export default component.exports